var map = {
	"./drug_card_layout__same__en.png": "c8c7",
	"./drug_card_layout__same__fi.png": "6fe1",
	"./drug_card_layout__same__sv.png": "dec9",
	"./drug_card_layout__separate__en.png": "253c",
	"./drug_card_layout__separate__fi.png": "1c4a",
	"./drug_card_layout__separate__sv.png": "3d62"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2cde";